import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';

let _organisationContacts = [];

let OrganisationContactStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    
    getAll: function() {
         return _organisationContacts.filter(function(e) { return e !== undefined; });
    },
    getByOrganisation: function(id) {
        return _organisationContacts.filter(function(e) { return e !== undefined && e.organisationId == id; });
    },
    add: function(entity) {
        if (!!entity.id && !!entity.organisationId) {
            let index = _organisationContacts.findIndex(function(e) { return e !== undefined && e.id == entity.id && e.organisationId == entity.organisationId; });
            if (0 <= index) {
                _organisationContacts[index] = entity;
            } else {
                _organisationContacts.push(entity);
            }
        }
    },
    remove: function(id, organisationId) {
        let index = _organisationContacts.findIndex(function(e) { return e !== undefined && e.id == id && e.organisationId == organisationId; });
        if (0 <= index) {
            delete _organisationContacts[index];
        }
    }

});

OrganisationContactStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.ORGANISATION_CONTACT_LIST:
            action.data.forEach(OrganisationContactStore.add);
            OrganisationContactStore.emitChange();
            break;

        case ActionTypes.ORGANISATION_CONTACT_ADD:
            OrganisationContactStore.add(action.data);
            OrganisationContactStore.emitChange();
            break;

        case ActionTypes.ORGANISATION_CONTACT_ADD_ERROR:
            OrganisationContactStore.emitChange();
            break;

        case ActionTypes.ORGANISATION_CONTACT_REMOVE:
            if (!!action.data.id && !!action.data.organisationId && !!action.data.deleted) {
                OrganisationContactStore.remove(action.data.id, action.data.organisationId);
            }
            OrganisationContactStore.emitChange();
            break;

        case ActionTypes.ORGANISATION_CONTACT_REMOVE_ERROR:
            OrganisationContactStore.emitChange();
            break;


        default:
            break;

    }

});

export default OrganisationContactStore;
